// extracted by mini-css-extract-plugin
module.exports = {"header":"Form_header__97rZ7","boxBorder":"Form_boxBorder__1p3eT"};